<template >

  <v-tabs
    color="transparent"
    v-model="selectedTab"
  >
    <v-tabs-slider color="primary"></v-tabs-slider>
    <v-tab key="tab1">

      <v-icon>tune</v-icon>
    </v-tab>
    <v-tab
      key="tab2"
      :disabled="actionButton"
    >
      <v-icon>message</v-icon>
    </v-tab>
    <v-tab
      key="tab3"
      :disabled="actionButton"
    >
      <v-icon>file_copy</v-icon>
    </v-tab>
    <v-tab
      key="tab4"
      :disabled="actionButton"
    >
      <v-icon>format_align_center</v-icon>
    </v-tab>
    <v-tab
      key="tab5"
      :disabled="actionButton"
    >
      <v-icon>local_activity</v-icon>
    </v-tab>
    <!-- <v-tab key="tab5"  :disabled="actionButton" >
      <v-icon>format_align_center</v-icon>
    </v-tab> -->
    <v-tabs-items>
      <v-tab-item key="tab1">
        <vue-perfect-scrollbar
          class="chat-room--scrollbar lighten-5"
          v-bind:style="computeHeight"
        >
          <v-card flat>

            <v-card-text>
              <task-form ref="reftaskForm"></task-form>
            </v-card-text>

          </v-card>
        </vue-perfect-scrollbar>
      </v-tab-item>
      <v-tab-item key="tab2">
        <vue-perfect-scrollbar class="chat-room--scrollbar lighten-5">
          <task-conversation ref="reftaskconversation">
          </task-conversation>
        </vue-perfect-scrollbar>

      </v-tab-item>
      <v-tab-item key="tab3">
        <v-card flat>
          <file-list ref="reftaskfiles"></file-list>
        </v-card>
      </v-tab-item>
      <v-tab-item key="tab4">
        <v-card flat>
          <sub-task-tree ref="refsubtasktree"></sub-task-tree>

        </v-card>
      </v-tab-item>
      <v-tab-item key="tab5">
        <v-card flat>
          <task-activity-log ref="refsubtasktree"></task-activity-log>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
</template>

<script>
import TaskForm from '@/pages/task/taskForm';
import TaskConversation from '@/pages/task/taskConversation';
import FileList from '@/pages/task/FileList';
import SubTaskList from '@/pages/task/subTaskList';
import SubTaskTree from '@/pages/task/subtasktree';
import TaskActivityLog from '@/pages/task/taskActivityLog';
export default {
  components: {
    TaskForm,
    TaskConversation,
    FileList,
    SubTaskList,
    SubTaskTree,
    TaskActivityLog
  },
  data: () => ({
    height: {
      type: String,
      default: null,
    },
    selectedTab: null,
    actionButton: true,
  }),

  computed: {
    computeHeight () {
      return {
        height: this.height || ''
      };
    },

  },
  created () {
    window.getApp.$on('ENABLE_TASKACTION', () => {
      this.actionButton = false;
      this.selectedTab = null;
    });
    window.getApp.$on('DISABLE_TAB', action => {
      this.actionButton = action;
      this.selectedTab = null;
    });
    window.getApp.$on('TAB_CONVERSATION', () => {
      this.selectedTab = 'tab2';
      //alert('tab2');
    });
  },
  methods: {

  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/task/taskTabform.vue